var path = 'src/app/components/customer/landing-page/customer-landing-page.template.html';
var html = "<div id='customer-landing-page-div'>\n\n  <customer-breadcrumbs></customer-breadcrumbs>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;